import React, { useEffect } from 'react';
import s from './ApprovalProcessPage.module.css';
import Header from '../start-page/Header';
import Banner from './Banner';
import CtaSection from '../start-page/CtaSection';
import Footer from '../start-page/Footer';
import HeroSection from './HeroSection';
import DescribeSection from './DescribeSection';
import TextSection from './TextSection';
const ApprovalProcessPage: React.FC = () => {
    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, []);
    return (
        <div className={s.container}>
            <Header />
            <Banner />
            <HeroSection />
            <DescribeSection />
            <TextSection />
            <CtaSection />
            <Footer />
        </div>
    );
};

export default ApprovalProcessPage;
